import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import { Crown, Search, Users, CheckCircle } from 'lucide-react'

const ExecutiveSearch = () => {
  const services = [
    'Confidential executive search',
    'Comprehensive candidate assessment',
    'Market intelligence and insights',
    'Negotiation and onboarding support'
  ]

  return (
    <div>
      <section className="bg-gradient-to-br from-primary-800 via-primary-700 to-teal-700 text-white py-16 md:py-20">
        <div className="container-max">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">Executive Search Services</h1>
            <p className="text-lg md:text-xl text-primary-100">Senior-level talent acquisition for leadership positions</p>
            <div className="w-20 h-1 bg-accent-500 mx-auto mt-6 rounded-full"></div>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-max">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-primary-800 mb-6">C-Level and Executive Placements</h2>
              <p className="text-secondary-500 mb-6">Our executive search team specializes in identifying and attracting top-tier leadership talent. We understand the unique challenges of executive recruitment and deliver results that drive organizational success.</p>
              <ul className="space-y-3">
                {services.map((service, index) => (
                  <li key={index} className="flex items-center">
                    <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
                    <span className="text-secondary-600">{service}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <img src="https://images.unsplash.com/photo-1560472354-b33ff0c44a43?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Executive Search" className="rounded-lg shadow-xl" />
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ExecutiveSearch
